const Style = ({ attributes, clientId }) => {
	const { verticalAlign, textAlign, background, minHeight, padding } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		#psbParallaxSection-${clientId}{
			min-height: ${minHeight};
		}
		#psbParallaxSection-${clientId} .psbParallaxSection{
			justify-content: ${verticalAlign};
			text-align: ${textAlign};
			min-height: ${minHeight};
			padding: ${padding?.styles || '20px 30px'};
		}
		#psbParallaxSection-${clientId} .psbParallaxImg{
			${background?.styles || ''}
		}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;